"use strict";
import React from "react";
import _ from "underscore";
import TextDroppableInput from "../text_droppable_input";
import generalFormatter from "../../formatters/general";
import GeosuggestDroppableInput from "../geosuggest_dropable_input";
function defaultInputOption() {
  return "Select an Option";
}
function initialFieldsAndValues(props) {
  const fieldsToDisplay = props.extractedFields || [];
  const keys = _.pluck(fieldsToDisplay, "name");
  const labels = _.pluck(fieldsToDisplay, "label");
  const options = _.pluck(fieldsToDisplay, "options");
  const placeholders = _.pluck(fieldsToDisplay, "placeholder");
  const fieldsSourceObject = props.fieldsSourceObject;
  const fieldValue = (field) => {
    return fieldsSourceObject[field] || "";
  };
  return _.chain(_.zip(keys, labels, placeholders, options)).map(([k, l, p, o]) => [
    k,
    { label: l, value: fieldValue(k), placeholder: p, options: o }
  ]).object().value();
}
function isGeosuggestInput(name) {
  return name === "destination_name" || name === "origin_name";
}
function inputOptions(options) {
  const opts = [defaultInputOption()].concat(options);
  return opts.map((opt) => /* @__PURE__ */ React.createElement("option", { value: opt }, opt));
}
function updateValues(val, fields, name) {
  if (val != defaultInputOption()) {
    fields[name].value = val;
  } else {
    fields[name].value = null;
  }
}
function createOriginData(suggestion) {
  const description = suggestion.description;
  const addressComponents = suggestion.gmaps.address_components;
  const locationData = {
    origin_address_line_1: null,
    origin_address_line_2: null,
    origin_city: null,
    origin_name: description.split(",")[0],
    origin_postal_code: null,
    origin_state: null,
    origin_country: null,
    origin_lat: suggestion.location.lat,
    origin_lng: suggestion.location.lng
  };
  addressComponents.map((component) => {
    switch (component.types[0]) {
      case "subpremise":
        locationData.origin_address_line_2 = component.long_name;
        break;
      case "locality":
        locationData.origin_city = component.long_name;
        break;
      case "administrative_area_level_1":
        locationData.origin_state = component.short_name;
        break;
      case "postal_code":
        locationData.origin_postal_code = component.long_name;
        break;
      case "street_number":
        locationData.origin_address_line_1 = component.short_name;
        break;
      case "route":
        locationData.origin_address_line_1 = locationData.origin_address_line_1 + " " + component.short_name;
        break;
      case "country":
        locationData.origin_country = component.short_name;
        break;
    }
  });
  return locationData;
}
function createDestinationData(suggestion) {
  const description = suggestion.description;
  const addressComponents = suggestion.gmaps.address_components;
  const locationData = {
    destination_address_line_2: null,
    destination_address_line_1: null,
    destination_city: null,
    destination_name: description.split(",")[0],
    destination_postal_code: null,
    destination_state: null,
    destination_country: null,
    destination_lat: suggestion.location.lat,
    destination_lng: suggestion.location.lng
  };
  addressComponents.map((component) => {
    switch (component.types[0]) {
      case "subpremise":
        locationData.destination_address_line_2 = component.long_name;
        break;
      case "locality":
        locationData.destination_city = component.long_name;
        break;
      case "administrative_area_level_1":
        locationData.destination_state = component.short_name;
        break;
      case "postal_code":
        locationData.destination_postal_code = component.long_name;
        break;
      case "street_number":
        locationData.destination_address_line_1 = component.short_name;
        break;
      case "route":
        locationData.destination_address_line_1 = locationData.destination_address_line_1 + " " + component.short_name;
        break;
      case "country":
        locationData.destination_country = component.short_name;
        break;
    }
  });
  return locationData;
}
function clearName(state, name) {
  const fields = state.extractedFields;
  _.mapObject(fields, function(value, key) {
    fields[name].value = "";
  });
  return fields;
}
function mapSuggestionToFields(state, suggestion, name) {
  const fields = state.extractedFields;
  if (name == "origin_name") {
    const originData = createOriginData(suggestion);
    _.mapObject(originData, function(value, key) {
      if (fields[key] != void 0) {
        fields[key].value = value;
      } else {
        fields[key] = { value };
      }
    });
  } else if (name == "destination_name") {
    const destinationData = createDestinationData(suggestion);
    _.mapObject(destinationData, function(value, key) {
      if (fields[key] != void 0) {
        fields[key].value = value;
      } else {
        fields[key] = { value };
      }
    });
  }
  return fields;
}
function toBeCleanedFields(props) {
  return _.chain(props.extractedFields).where({ clean_amount: true }).map((f) => {
    return f["name"];
  }).value();
}
function possibleErrorMessage(props, fieldName) {
  if (fieldName === "load_id") {
    var errorMessage = props.loadIdError;
  }
  if (errorMessage) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box alert load-detail__load-id-error" }, errorMessage);
  }
}
function formatLabel(props, label, name) {
  return isRequiredField(props, name) ? label + "*" : label;
}
function hasExtractedFields(state) {
  return !_.isEmpty(state.extractedFields);
}
function isRequiredField(props, name) {
  return _.contains(props.requiredFields || [], name);
}
function isDateField(props, name) {
  return !!(_.findWhere(props.extractedFields, { name }) || {}).date_field;
}
function inputClass(props, name, value) {
  if (isRequiredField(props, name) && !value) {
    return "load-detail__invalid-input";
  }
}
function shouldBeCleaned(state, name, event) {
  return _.contains(state.toBeCleanedFields, name) && event.type == "drop";
}
function shouldRenderRows(props) {
  if (props.renderRows !== null && props.renderRows !== void 0) {
    return props.renderRows;
  } else {
    return true;
  }
}
function fieldContainerClass(props) {
  return props.fieldContainerClass || "";
}
function containerClass(props) {
  return props.containerClass || "";
}
export default React.createClass({
  getInitialState() {
    return {
      extractedFields: initialFieldsAndValues(this.props),
      toBeCleanedFields: toBeCleanedFields(this.props)
    };
  },
  componentWillReceiveProps(newProps) {
    if (this.props.sourceId !== newProps.sourceId || this.props.isDirty) {
      this.setState({
        extractedFields: initialFieldsAndValues(newProps)
      });
    }
  },
  render() {
    if (hasExtractedFields(this.state)) {
      const fields = _.pairs(this.state.extractedFields) || [];
      const pairsOfFields = _.toArray(
        _.groupBy(fields, (x, i) => Math.floor(i / 2))
      );
      const renderField = (field, itemClass, i) => {
        if (field) {
          const [name, { label, value, placeholder, options }] = field;
          var labelElement;
          if (placeholder) {
            labelElement = /* @__PURE__ */ React.createElement("label", { "data-tooltip": true, "aria-haspopup": "true", title: placeholder }, formatLabel(this.props, label, name), /* @__PURE__ */ React.createElement("i", { className: "fi-info load-detail__extracted-field-has-tooltip" }));
          } else {
            labelElement = /* @__PURE__ */ React.createElement("label", null, formatLabel(this.props, label, name));
          }
          return /* @__PURE__ */ React.createElement("div", { className: itemClass, key: "extracted_field_field" + i }, labelElement, this.inputForField(name, value, options));
        }
      };
      const fieldList = (rowOfFields, rowClass, rowItemClass, i) => {
        return /* @__PURE__ */ React.createElement("div", { className: rowClass, key: "extracted_field_row" + i }, rowOfFields.map(_.partial(renderField, _, rowItemClass, _)));
      };
      if (shouldRenderRows(this.props)) {
        return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, pairsOfFields.map(
          _.partial(fieldList, _, "row", "small-5 column", _)
        )));
      } else {
        return fieldList(
          fields,
          containerClass(this.props),
          fieldContainerClass(this.props),
          0
        );
      }
    } else {
      return null;
    }
  },
  inputForField(name, value, options) {
    if (isDateField(this.props, name)) {
      return /* @__PURE__ */ React.createElement("div", { className: inputClass(this.props, name, value) }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "date",
          disabled: this.props.readOnly,
          placeholder: "Date",
          value: value.substring(0, 10),
          onChange: this.inputChangedHandlerFor(name)
        }
      ));
    } else if (options) {
      return /* @__PURE__ */ React.createElement("div", { className: inputClass(this.props, name, value) }, /* @__PURE__ */ React.createElement(
        "select",
        {
          type: "text",
          placeholder: "Select",
          disabled: this.props.readOnly,
          value,
          onChange: this.inputChangedHandlerFor(name)
        },
        inputOptions(options)
      ));
    } else if (isGeosuggestInput(name)) {
      return /* @__PURE__ */ React.createElement("div", { className: inputClass(this.props, name, value) }, /* @__PURE__ */ React.createElement(
        GeosuggestDroppableInput,
        {
          type: "text",
          disabled: this.props.readOnly,
          valueLink: this.autocompleteHandler(name),
          geosuggestClear: this.autocompleteClearHandler(name),
          initialValue: value,
          value,
          nonSelect: this.nonSelect(name)
        }
      ));
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: inputClass(this.props, name, value) }, /* @__PURE__ */ React.createElement(
        TextDroppableInput,
        {
          type: "text",
          disabled: this.props.readOnly,
          value,
          onDrop: this.inputChangedHandlerFor(name),
          onChange: this.inputChangedHandlerFor(name)
        }
      ), possibleErrorMessage(this.props, name));
    }
  },
  inputChangedHandlerFor(name) {
    return (event, value) => {
      const fields = this.state.extractedFields;
      var val = value || event.currentTarget.value;
      if (shouldBeCleaned(this.state, name, event)) {
        val = generalFormatter.cleanAmount(val).toString() || "0.00";
      }
      updateValues(val, fields, name);
      this.setState({ extractedFields: fields });
      this.props.onChange(_.mapObject(fields, _.property("value")));
    };
  },
  autocompleteHandler(name) {
    var props = this.props;
    var component = this;
    return {
      requestChange: function(suggestion) {
        const updatedFields = mapSuggestionToFields(
          component.state,
          suggestion,
          name
        );
        component.setState({ extractedFields: updatedFields });
        props.onChange(_.mapObject(updatedFields, _.property("value")));
        props.onLocationChange(updatedFields);
      }
    };
  },
  autocompleteClearHandler(name) {
    var props = this.props;
    var component = this;
    return {
      requestChange: function() {
        const updatedFields = clearName(component.state, name);
        component.setState({ extractedFields: updatedFields });
        props.onChange(_.mapObject(updatedFields, _.property("value")));
        props.onLocationChange(updatedFields);
      }
    };
  },
  nonSelect(name) {
    var props = this.props;
    var component = this;
    return {
      requestChange: function(inputValue) {
        const fields = component.state.extractedFields;
        fields[name].value = inputValue;
        component.setState({ extractedFields: fields });
        props.onChange(_.mapObject(fields, _.property("value")));
        props.onLocationChange(fields);
      }
    };
  }
});
